export const METRIC_COUNT_PATH = 'localization.ugc.translate.ajax_error';

export const ERROR_CONTEXT = 'Gig page ugc translation error';
